import { Link1 } from "../../../../src/components/images/support/subscriptions/Link1.generated";
import { Link2 } from "../../../../src/components/images/support/subscriptions/Link2.generated";
import { Link3 } from "../../../../src/components/images/support/subscriptions/Link3.generated";
import * as React from 'react';
export default {
  Link1,
  Link2,
  Link3,
  React
};